import * as React from "react";


export function ShowPreviousPrayer({
    text, opacity,
}: {
    text: string;
    opacity: number;
}) {
    return <div style={{ opacity }}>{text}</div>;
}
